import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import ModalCrud from "./DojoModal";
import { DoLogout } from "../Utils";

export default function BulkProcessDojos(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dojos, setDojos] = useState([]);
  const [dojoDetail, setDojoDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    GetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const GetData = async () => {
    setLoading(true);

    const res = await axios
      .get(
        `${API_URL}/temp-dojos?populate=*&sort[0]=name%3Aasc&filters[state][$eq]=NEW&pagination[pageSize]=1000`,
        headerRequest
      )
      .catch((error) => {
        console.log("Error with temp-dojos:", error);
        if (error.response.status === 401) DoLogout();
      });
    const tempDojos = res.data.data;

    Promise.all(
      tempDojos.map(async (d) => {
        const resCreated = await axios.get(
          `${API_URL}/users/${d.attributes.createdByUser}`,
          headerRequest
        );
        const userCreated = resCreated.data;
        if (userCreated) {
          d.createdByUserName = userCreated.name + " " + userCreated.lastname;
        } else {
          d.createdByUserName = `No existe`;
        }

        if (moment(d.attributes.startDate, true).isValid() !== true) {
          d.attributes.startDate = `Inválida. (${d.attributes.startDate})`;
        }
        if (moment(d.attributes.endDate, true).isValid() !== true) {
          d.attributes.endDate = `Inválida. (${d.attributes.endDate})`;
        }

        d.result = "A procesar";

        return d;
      })
    ).then((tempDojos) => {
      setDojos(tempDojos);
      setLoading(false);
    });
  };

  function GetError(error) {
    return error.response
      ? "ERROR: " + error.response.data?.error?.message
      : "ERROR: " + error.mesage;
  }

  const processData = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Procesar todos los items pendientes
    for (let i = 0; i < dojos.length; i++) {
      const item = dojos[i];

      // Validar en base a lo cargado
      // if (!item.userId) {
      //   dojos[i].result = "ERROR: DocNumber no existe";
      //   continue;
      // }
      if (moment(item.attributes.startDate, true).isValid() !== true) {
        dojos[i].result = "ERROR: Fecha es inválida";
        continue;
      }
      if (moment(item.attributes.endDate, true).isValid() !== true) {
        dojos[i].result = "ERROR: Fecha es inválida";
        continue;
      }

      let isError = false;

      let reqDojos = {
        name: null,
        startDate: null,
        endDate: null,
      };
      await axios
        .get(`${API_URL}/dojos/${item.id}`, headerRequest)
        .then((d) => {
          if (d.data.length > 0) reqDojos = d.data[0];
        })
        .catch((error) => {
          isError = true;
          dojos[i].result = GetError(error);
        });
      if (isError) continue;

      reqDojos.name = item.attributes.name.toUpperCase();
      reqDojos.startDate = item.attributes.startDate;
      reqDojos.endDate = item.attributes.endDate;

      let processToBeMade = "";
      if (reqDojos.id >= 0) {
        processToBeMade = "UPDATED";
        await axios
          .put(`${API_URL}/dojos/${reqDojos.id}`, reqDojos, headerRequest)
          .catch((error) => {
            isError = true;
            console.log("Error with put dojos:", error.response);
            dojos[i].result = GetError(error);
          });
      } else {
        processToBeMade = "CREATED";
        await axios
          .post(`${API_URL}/dojos`, reqDojos, headerRequest)
          .catch((error) => {
            isError = true;
            console.log("Error with post dojos:", error.response);
            dojos[i].result = GetError(error);
          });
      }
      if (isError) continue;

      // Una vez creado/actualizado, marcar el temp como procesado
      const reqTempDojos = {
        data: {
          state: processToBeMade,
        },
      };
      await axios
        .put(`${API_URL}/temp-dojos/${item.id}`, reqTempDojos, headerRequest)
        .catch((error) => {
          isError = true;
          console.log("Error with post temp-dojos:", error.response);
          dojos[i].result = GetError(error);
        });
      if (isError) continue;

      dojos[i].result = "OK";
    }
    setDojos(dojos.filter((e) => e.result !== "OK"));
    setLoading(false);
  };

  const EditData = (data) => {
    setDojoDetail(data);
    setShowModal(true);
  };

  const renderData = (
    <>
      <Table
        striped
        hover
        size="sm"
        responsive="sm"
        style={{ fontSize: ".8em" }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Direccion</th>
            <th>Localidad</th>
            <th>Inicio</th>
            <th>Responsable</th>
            <th>Alta</th>
            <th>Resultado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {dojos.length < 1 ? (
            <tr>
              <td colSpan="8" align="center">
                No hay dojos pendientes de procesar.
              </td>
            </tr>
          ) : (
            dojos.map((exam) => (
              <tr key={exam.id}>
                <td align="center">{exam.id}</td>
                <td align="left">{exam.attributes.name}</td>
                <td align="left">{exam.attributes.address}</td>
                <td align="left">{exam.attributes.locality}</td>
                <td align="center">
                  {moment(exam.attributes.startDate).format(displayFormat)}
                </td>
                <td align="center">
                  {exam.attributes.responsible.data.attributes.lastname}
                </td>
                <td align="center">{exam.createdByUserName}</td>
                <td align="left">{exam.result}</td>
                <td align="center">
                  <Button
                    size="sm"
                    className="btn-xs"
                    onClick={() => EditData(exam)}
                    variant="warning"
                  >
                    Editar
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Button
        size="sm"
        variant="success"
        onClick={(e) => {
          processData(e);
        }}
      >
        PROCESAR
      </Button>
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          dojo={dojoDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetData();
          }}
        />
      )}
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>PROCESAR DOJOS</h4>
      <p>Revise la lista de pendientes y presione Procesar</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
